var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashiconsEditPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2001 19H7.6001V68.4H45.6001V60.8H15.2001V19ZM68.0201 12.92L63.0801 7.97999C61.5601 6.45999 58.9001 6.07999 57.0001 7.59999L53.2001 11.4H19.0001V57H53.2001V34.2L68.4001 19C69.9201 17.1 69.5401 14.44 68.0201 12.92ZM46.3601 35.72L36.8601 39.14L40.2801 29.64L57.0001 12.92L63.0801 19L46.3601 35.72Z",
    fill: "#8BAEC3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashiconsEditPage);
export default __webpack_public_path__ + "static/media/dashicons-edit-page.753063a6d9e81bf202a2e38b816fab0c.svg";
export { ForwardRef as ReactComponent };